import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { captureRedactedPageView } from '@/lib/customerPageView';

export function PostHogPageView() {
  const { pathname } = useLocation();

  useEffect(() => {
    captureRedactedPageView();
  }, [pathname]);

  return null;
}
